/* Woof & Cook · landing v2 behaviour
   Buy box (variant, bump, free-delivery bar, pincode check, direct-to-checkout),
   proxy CTAs (closing section + sticky bar), sticky bar visibility, portion calculator.
   Loaded by several sections with `defer`; the guard below makes it run once. */
(function () {
  if (window.__lpInit) return;
  window.__lpInit = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function readConfig(el) {
    var node = el.querySelector('script[data-lp-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function money(cents, cfg) {
    var amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(cfg.locale || 'en-IN', {
        style: 'currency', currency: cfg.currency || 'INR',
        maximumFractionDigits: amount % 1 === 0 ? 0 : 2
      }).format(amount);
    } catch (e) { return '₹' + Math.round(amount); }
  }

  function track(name, params) {
    params = params || {};
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
    else if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, params));
  }

  /* Pincode rules: "560038", "560*" (prefix) or "560001-560103" (range). */
  function parsePins(list) {
    return (list || []).map(function (raw) {
      var s = String(raw).trim();
      if (!s) return null;
      if (s.slice(-1) === '*') return { type: 'prefix', v: s.slice(0, -1) };
      var m = s.match(/^(\d{6})\s*-\s*(\d{6})$/);
      if (m) return { type: 'range', a: +m[1], b: +m[2] };
      return { type: 'exact', v: s.replace(/\D/g, '') };
    }).filter(Boolean);
  }
  function pinAllowed(pin, rules) {
    if (!rules.length) return true;
    var n = +pin;
    return rules.some(function (r) {
      if (r.type === 'prefix') return pin.indexOf(r.v) === 0;
      if (r.type === 'range') return n >= r.a && n <= r.b;
      return pin === r.v;
    });
  }

  var primary = null; // the first buy box on the page drives proxies + sticky bar

  function initBuyBox(box) {
    var cfg = readConfig(box);
    if (!cfg || !cfg.variants || !cfg.variants.length) return;
    var rules = parsePins(cfg.pincodes);
    var state = {
      variant: cfg.variants.find(function (v) { return v.available; }) || cfg.variants[0],
      bump: false,
      pin: '',
      pinOk: null
    };

    var $ = function (sel) { return box.querySelector(sel); };
    var select = $('[data-lp-variant]');
    var bump = $('[data-lp-bump]');
    var pinInput = $('[data-lp-pin-input]');
    var pinBtn = $('[data-lp-pin-btn]');
    var pinMsg = $('[data-lp-pin-msg]');
    var cta = $('[data-lp-primary-cta]');

    function total() {
      return state.variant.price + (state.bump && cfg.bump ? cfg.bump.price : 0);
    }

    function render() {
      var v = state.variant;
      var priceEls = document.querySelectorAll('[data-lp-sync-price]');
      priceEls.forEach(function (el) { el.textContent = money(v.price, cfg); });
      document.querySelectorAll('[data-lp-sync-compare]').forEach(function (el) {
        el.textContent = v.compare > v.price ? money(v.compare, cfg) : '';
        el.hidden = !(v.compare > v.price);
      });
      var badge = $('[data-lp-badge]');
      if (badge && !cfg.badgeFixed) {
        var pct = v.compare > v.price ? Math.round((1 - v.price / v.compare) * 100) : 0;
        badge.textContent = pct ? cfg.badgeTemplate.replace('{percent}', pct) : '';
        badge.hidden = !pct;
      }
      var ctaPrice = $('[data-lp-cta-price]');
      if (ctaPrice) ctaPrice.textContent = money(total(), cfg);

      var msg = $('[data-lp-ship-msg]');
      var fill = $('[data-lp-ship-fill]');
      if (cfg.threshold > 0 && msg && fill) {
        var left = cfg.threshold - total();
        msg.textContent = left > 0
          ? cfg.shipLeft.replace('{amount}', money(left, cfg))
          : cfg.shipDone;
        fill.style.width = Math.min(100, Math.round(total() / cfg.threshold * 100)) + '%';
      }

      if (cta) {
        var blocked = (cfg.requirePin && state.pinOk !== true) || !v.available;
        cta.setAttribute('aria-disabled', blocked ? 'true' : 'false');
        cta.href = checkoutUrl();
      }
    }

    function checkoutUrl() {
      var items = [state.variant.id + ':' + (cfg.qty || 1)];
      if (state.bump && cfg.bump) items.push(cfg.bump.id + ':1');
      var q = [];
      if (cfg.discount) q.push('discount=' + encodeURIComponent(cfg.discount));
      if (state.pinOk && state.pin) q.push('checkout[shipping_address][zip]=' + state.pin);
      if (cfg.pageHandle) q.push('attributes[landing_page]=' + encodeURIComponent(cfg.pageHandle));
      return root + 'cart/' + items.join(',') + (q.length ? '?' + q.join('&') : '');
    }

    function checkPin() {
      var pin = (pinInput.value || '').replace(/\D/g, '').slice(0, 6);
      pinInput.value = pin;
      state.pin = pin;
      if (pin.length !== 6) {
        state.pinOk = null;
        pinMsg.dataset.state = 'no';
        pinMsg.textContent = cfg.pinInvalid;
      } else if (pinAllowed(pin, rules)) {
        state.pinOk = true;
        pinMsg.dataset.state = 'ok';
        pinMsg.textContent = cfg.pinOk.replace('{pincode}', pin);
        try { sessionStorage.setItem('lp_pin', pin); } catch (e) {}
      } else {
        state.pinOk = false;
        pinMsg.dataset.state = 'no';
        pinMsg.textContent = cfg.pinNo.replace('{pincode}', pin);
      }
      track('lp_pincode_check', { pincode_ok: !!state.pinOk });
      render();
    }

    if (select) select.addEventListener('change', function () {
      var id = +select.value;
      state.variant = cfg.variants.find(function (v) { return v.id === id; }) || state.variant;
      render();
    });
    if (bump) bump.addEventListener('change', function () { state.bump = bump.checked; render(); });
    if (pinInput && pinBtn && pinMsg) {
      pinBtn.addEventListener('click', checkPin);
      pinInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); checkPin(); } });
      try {
        var saved = sessionStorage.getItem('lp_pin');
        if (saved) { pinInput.value = saved; checkPin(); }
      } catch (e) {}
    }
    if (cta) cta.addEventListener('click', function (e) {
      if (cta.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        if (pinInput && cfg.requirePin && state.pinOk !== true) {
          pinInput.focus();
          if (pinMsg && !pinMsg.textContent) { pinMsg.dataset.state = 'no'; pinMsg.textContent = cfg.pinRequired; }
        }
        return;
      }
      track('lp_cta_click', { variant_id: state.variant.id, value: total() / 100, currency: cfg.currency, bump: state.bump });
    });

    render();
    if (!primary) primary = { box: box, cta: cta };
  }

  /* Closing-section and sticky-bar buttons reuse the hero buy box (same variant, bump, pincode). */
  function initProxies() {
    document.querySelectorAll('[data-lp-proxy]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!primary || !primary.cta) return; // fall back to the button's own href
        e.preventDefault();
        var mode = btn.getAttribute('data-lp-proxy');
        if (mode === 'scroll' || primary.cta.getAttribute('aria-disabled') === 'true') {
          primary.box.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        primary.cta.click(); // tracks + follows the live checkout link
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-lp-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var target = primary && primary.cta;
    if (!target) { bar.classList.add('is-visible'); return; }
    var hiders = Array.prototype.slice.call(document.querySelectorAll('[data-lp-hide-sticky]'));
    var ctaGone = false, hiderOn = {};
    function update() {
      var anyHider = Object.keys(hiderOn).some(function (k) { return hiderOn[k]; });
      bar.classList.toggle('is-visible', ctaGone && !anyHider);
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { ctaGone = !en.isIntersecting && en.boundingClientRect.top < 0; });
      update();
    }).observe(target);
    if (hiders.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { hiderOn[en.target.dataset.lpKey] = en.isIntersecting; });
        update();
      });
      hiders.forEach(function (h, i) { h.dataset.lpKey = 'h' + i; io.observe(h); });
    }
  }

  /* Portion calculator: RER = 70 × kg^0.75, × life-stage factor, ÷ kcal per gram. */
  function initCalc(el) {
    var cfg = readConfig(el);
    if (!cfg) return;
    var kg = el.querySelector('[data-lp-calc-kg]');
    var stage = el.querySelector('[data-lp-calc-stage]');
    var outG = el.querySelector('[data-lp-calc-grams]');
    var outP = el.querySelector('[data-lp-calc-packs]');
    var outC = el.querySelector('[data-lp-calc-cost]');
    var cta = el.querySelector('[data-lp-calc-cta]');
    function run() {
      var w = parseFloat(kg.value);
      var f = parseFloat(stage.value);
      if (!(w > 0) || !(cfg.kcalPer100 > 0) || !(f > 0)) {
        outG.textContent = '—'; outP.textContent = '—'; outC.textContent = '—';
        if (cta) { cta.hidden = true; }
        return;
      }
      var kcal = 70 * Math.pow(w, 0.75) * f;
      var grams = Math.round(kcal / cfg.kcalPer100 * 100 / 5) * 5;
      var packs = Math.max(1, Math.ceil(grams * cfg.days / cfg.packGrams));
      var cost = packs * cfg.price;
      outG.textContent = grams + ' g';
      outP.textContent = packs;
      outC.textContent = money(cost, cfg);
      if (cta && cfg.variantId) {
        cta.hidden = false;
        cta.href = root + 'cart/' + cfg.variantId + ':' + packs + (cfg.discount ? '?discount=' + encodeURIComponent(cfg.discount) : '');
        cta.textContent = cfg.ctaTemplate.replace('{packs}', packs).replace('{total}', money(cost, cfg));
      }
    }
    kg.addEventListener('input', run);
    stage.addEventListener('change', run);
    if (cta) cta.addEventListener('click', function () { track('lp_calc_cta_click', { packs: outP.textContent }); });
    run();
  }

  function boot() {
    document.querySelectorAll('[data-lp-buybox]').forEach(initBuyBox);
    document.querySelectorAll('[data-lp-calc]').forEach(initCalc);
    initProxies();
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme editor: re-run when a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-lp-buybox]').forEach(initBuyBox);
    e.target.querySelectorAll('[data-lp-calc]').forEach(initCalc);
  });
})();
